import ThermalPrinterBase from "../../services/thermalPrinter/ThermalPrinterBase";
import PrintJobNiceloopV1Builder from "~/class/printer/PrintJobNiceloopV1Builder";


export default class ThermalPrintJob extends ThermalPrinterBase {  
    printMoveItems(job : any, options:any){
      const jobMove =  this.withPayload(job, options)
      console.log("jobMove=>", jobMove)
      this.print_data = jobMove
      return this       
          
    }   
    
    withPayload(job : any, options:any){
      const payload = {...job, ...options}
      const printJobBuilder =  new PrintJobNiceloopV1Builder(options?.productsStore)
      const jobMove =  printJobBuilder.makePrintJobMove(payload).build();
      return jobMove 
    }

    setPayload(payload:any){
      this.print_data = payload
      return this
    }
}
